















import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class SidebarDatabases extends Vue {
  public $confirm: any;
  @Prop(Function) private removeHandler: any;
  @Prop(Function) private elementHandler: any;
  @Prop(Array) private databaseList!: any[];
  private toggleDeleteModal(db: any) {
    this.$confirm(
      'Are you sure, you want to delete database from list?',
      'Warning',
      {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning',
        confirmButtonClass: 'el-button el-button--danger is-plain',
        cancelButtonClass: 'el-button el-button--primary is-plain',
      },
    )
      .then(() => {
        this.removeHandler(db);
      })
      .catch(() => true);
  }
}
